<template>
  <div class="h-stepper-container">
    <div v-if="!!title" class="horizontal-stepper-header">
      <div class="horizontal-stepper-header__title">
        {{ trans(title) }}
      </div>
      <span v-if="iconInfo" class="horizontal-stepper-header__info" @click="$emit('click-info')" />
    </div>
    <horizontal-stepper-common v-if="stepperType === 'common'" :stepper="stepper" />
    <horizontal-stepper-guided-search v-if="stepperType === 'guided-search'" :stepper="stepper" />
  </div>
</template>

<script>
import HorizontalStepperCommon from '@components-molecules/HorizontalStepperCommon';
import HorizontalStepperGuidedSearch from '@components-molecules/HorizontalStepperSausage';
import { stepperMixin } from './stepperMixin';

export default {
  name: 'HorizontalStepper',
  components: {
    HorizontalStepperCommon,
    HorizontalStepperGuidedSearch,
  },
  mixins: [ stepperMixin ],
  computed: {
    stepper() {
      const stepper = [];
      for (let i = 0; i < this.steps.length; i++) {
        stepper.push({
          stepColor: this.getStepColor(i),
          isLastStep: this.isLastStep(i + 1),
          lineColor: this.getColor(i),
        });
      }
      return stepper;
    },
  },
};
</script>
